module.exports = __webpack_public_path__ + "public/img/logo-certif-new.e326d4e3.png";